import { TFunction } from 'i18next';
import { Country } from '@urc-ui/store/api/countries/types';

export const getCountryNameForCountryCode = (translate: TFunction, countryCode = 'US'): string => {
  const normalizedCountryCode = countryCode.toUpperCase();
  const key = `sspa_rcm_ad_country_${normalizedCountryCode.toLowerCase()}`;
  return translate(key, normalizedCountryCode);
};

export const mapToCountryList = (map: unknown): Country[] => {
  if (!map || typeof map !== 'object' || Array.isArray(map)) return [];

  return Object.entries(map as Record<string, string>).map(([countryCode, marketplaceId]) => ({
    countryCode: countryCode === 'UK' ? 'GB' : countryCode,
    marketplaceId
  }));
};

export const getAccessibleMarketplaces = (): { data: Country[] } => {
  return {
    data: mapToCountryList(window.AppContext?.AccessibleMarketplaces)
  };
};
